<template>
  <a-spin :spinning="loading">
    <div class="main">
      <a-card :bordered="false">
        <h3>
          个股自动审核配置
          <a-switch
            class="switch_style"
            v-model="form.status"
            @change="changeState"
            size="small"
            :loading="submitLoading"
            checked-children="开"
            un-checked-children="关" />
        </h3>
        <div>开启后对消息包含的个股信息进行机审辅助</div>
      </a-card>
      <div class="block_line"></div>
      <a-form-model
        class="form_main"
        v-if="form.status"
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="消息类型" prop="dealTypeList">
          <a-select
            mode="multiple"
            showArrow
            v-model="form.dealTypeList"
            :options="options.dealTypeListOpt"
            show-search
            :filter-option="filterOption"
            allowClear
            placeholder="请选择消息类型"
          ></a-select>
        </a-form-model-item>
        <a-form-model-item label="个股自动审核结果" prop="autoAuditMode">
          <a-radio-group
            v-model="form.autoAuditMode"
            :options="options.autoAuditModeOpt"
            @change="changeMode"
          ></a-radio-group
          ><br />
          <a-radio-group
            v-if="form.autoAuditMode === 2"
            v-model="form.autoAuditScope"
            :options="options.autoAuditScopeOpt"
          ></a-radio-group>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 8, offset: 8 }">
          <a-button type="primary" @click="onSubmit" :loading="submitLoading">保存</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-spin>
</template>

<script>
import { getCustomConfig, saveCustomConfig } from '@/api/account'
export default {
  components: {},
  props: {},
  data() {
    return {
      options: {
        dealTypeListOpt: [
          { label: '文本', value: 1 }
        ],
        autoAuditModeOpt: [
          { label: '参考值', value: 1 },
          { label: '决定值', value: 2 }
        ],
        autoAuditScopeOpt: [
          { label: '全部开启', value: 0 },
          { label: '仅老师发言', value: 1 },
          { label: '仅客户发言', value: 2 }
        ]
      },
      labelCol: { span: 8 },
      wrapperCol: { span: 8 },
      other: '',
      form: {
        status:false,
        dealTypeList: [],
        autoAuditMode: undefined,
        autoAuditScope: undefined
      },
      rules: {
        dealTypeList: [{ required: true, message: '请选择消息类型', trigger: 'change' }]
      },
      currentInfo: {},
      submitLoading: false,
      loading:false
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getCustomConfig()
  },
  methods: {
    changeState(checked){
      if(!checked){
        this.saveCustomConfig({status:0,id:this.currentInfo.id})
      }
    },
    changeMode(e) {
      const value = e.target.value
      if (value === 1) {
        this.form.autoAuditScope = undefined
      } else if (value === 2) {
        this.form.autoAuditScope = 0
      }
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const params = {
            id: this.currentInfo.id,
            status: this.form.status ? 1 : 0,
            dealTypeList: this.form.dealTypeList,
            autoAuditScope: this.form.autoAuditScope,
            autoAuditMode: this.form.autoAuditMode
          }
          this.saveCustomConfig(params)
        } else {
          return false
        }
      })
    },
    async getCustomConfig() {
      try {
        // type 1:个股自动审核
        this.loading = true
        const { result, code } = await getCustomConfig({ type: 1 })
        this.loading = false
        if(code===1){
          this.form.dealTypeList = result.dealTypeList
          this.form.autoAuditMode = result.autoAuditMode
          this.form.autoAuditScope = result.autoAuditScope
          this.form.status = result.status === 1
          this.currentInfo = result
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    async saveCustomConfig(params) {
      try {
        this.submitLoading = true
        const { result, code, message } = await saveCustomConfig(params)
        this.submitLoading = false
        console.log(result, code)
        if (code === 1) {
          this.$message.success('保存配置成功')
        } else {
          // this.$message.error(message)
        }
      } catch (error) {
        this.submitLoading = false
        console.log(error)
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  .switch_style {
    float: right;
    margin-right: 10px;
  }
  .block_line{
    background-color: #f1f1f1;
    height: 16px;
  }
  .form_main {
    margin-top: 16px;
    padding: 32px;
    padding-bottom: 8px;
    background-color: #fff;
  }
}
</style>

